import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { handleAuthentication, showSnackBar } from "@containers/App/reducer"
import { parsePageInfoWidgets } from "./parser"

const initialState = {
    isLoading: false,
    isFetched: false,
    error: null,
    pageInfoWidgets: {},
    defaultSelectedProcess: {},
}

export const dioRxProcessingSlice = createSlice({
    name: "dioRxProcessingData",
    initialState: initialState,
    reducers: {
        reset: () => initialState,
        setInitialPageData: (state, action) => {
            state.isLoading = false
            state.isFetched = true
            state.error = false
            const { widgets } = parsePageInfoWidgets(action.payload?.job_data)
            state.pageInfoWidgets = widgets
        },
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchDioRxProcessingData.fulfilled, (state, action) => {
            state.isLoading = false
            state.isFetched = true
            state.error = false
            const { widgets } = parsePageInfoWidgets(action.payload)
            state.pageInfoWidgets = widgets
        }),
            builder.addCase(fetchDioRxProcessingData.pending, (state) => {
                state.isLoading = true
                state.isFetched = false
                state.error = false
            }),
            builder.addCase(fetchDioRxProcessingData.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload ? action.payload : true
                state.isFetched = false
            })
        builder.addCase(createDioCart.fulfilled, (state, action) => {
            state.isLoading = false
            state.isFetched = true
            state.error = false
            const { widgets } = parsePageInfoWidgets(action.payload?.job_data)
            state.pageInfoWidgets = widgets
        })
    },
})

export const fetchDioRxProcessingData = createAsyncThunk(
    "dioRxProcessingData/fetchDioRxProcessingData",
    async (_arg, { extra, rejectWithValue, dispatch }) => {
        const { api } = extra
        const { jobId, successCallback } = _arg
        try {
            const res = await api.get(`api/v4/latest_job_event?job_id=${jobId}`)
            if (typeof successCallback === "function") {
                successCallback()
            }
            return Promise.resolve(res.data)
        } catch (err) {
            const { errorCallback, navigate } = _arg
            if (typeof errorCallback === "function") {
                errorCallback()
            }
            const onServer = typeof window === "undefined"
            if (err?.status_code !== 403 && err?.status_code !== 401) {
                showSnackBar(dispatch, err.error.message)
            }
            if (err?.status_code === 400) {
                if (err.error.errors?.[0]?.target_url) {
                    navigate(err.error.errors?.[0]?.target_url, { replace: true })
                } else {
                    navigate("/done-in-one/prescription-order")
                }
            }
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            return rejectWithValue({ message: err.error.message })
        }
    }
)
export const cancelJob = createAsyncThunk(
    "dioRxProcessingData/cancelDioJob",
    async (_arg, { extra, rejectWithValue, dispatch }) => {
        const { api } = extra
        const { jobId, successCallback } = _arg
        try {
            const res = await api.post(`api/v4/cancel_job`, { job_id: jobId })
            await Promise.resolve()
            if (typeof successCallback === "function") successCallback(res)
            return Promise.resolve(res?.data)
        } catch (err) {
            if (err?.status_code !== 403 || err?.status_code !== 401) {
                showSnackBar(dispatch, err.error.message)
            }
            const onServer = typeof window === "undefined"
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            return rejectWithValue(err.error)
        }
    }
)
export const createDioCart = createAsyncThunk(
    "dioRxProcessingData/createDoneInOneCart",
    async (_arg, { extra, rejectWithValue, dispatch }) => {
        const { api } = extra
        const { payload, successCallback, errorCallback, navigate } = _arg
        try {
            const res = await api.post(`api/v4/create_cart`, payload)
            await Promise.resolve()
            successCallback?.(res)
            return Promise.resolve(res?.data)
        } catch (err) {
            errorCallback?.(err)
            if (err?.status_code !== 403 || err?.status_code !== 401) {
                showSnackBar(dispatch, err.error.message)
            }
            const onServer = typeof window === "undefined"
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            if (err.status_code === 400 && err.error?.message) {
                showSnackBar(dispatch, err.error?.message)
                if (err.error?.errors?.[0]?.target_url) {
                    navigate(err.error?.errors?.[0]?.target_url)
                }
            }
            return rejectWithValue(err.error)
        }
    }
)

export const updateJob = createAsyncThunk(
    "dioRxProcessingData/updateDoneInOneCartJob",
    async (_arg, { extra, rejectWithValue, dispatch }) => {
        const { api } = extra
        const { payload, successCallback } = _arg
        try {
            const res = await api.post(`api/v4/update_job`, payload)
            await Promise.resolve()
            if (typeof successCallback === "function") successCallback(res)
            return Promise.resolve(res?.data)
        } catch (err) {
            if (err?.status_code !== 403 || err?.status_code !== 401) {
                showSnackBar(dispatch, err.error.message)
            }
            const onServer = typeof window === "undefined"
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            return rejectWithValue(err.error)
        }
    }
)

export const dioRxProcessingReducer = dioRxProcessingSlice.reducer
export const { reset, setInitialPageData } = dioRxProcessingSlice.actions
